import {
  APP_REPORT_FILTER_FIELD_REQUEST,
  APP_REPORT_FILTER_FIELD_REQUEST_SUCCESS,
  APP_REPORT_FILTER_FIELD_REQUEST_FAILURE,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const appReportFilterFieldsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case APP_REPORT_FILTER_FIELD_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case APP_REPORT_FILTER_FIELD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case APP_REPORT_FILTER_FIELD_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    default:
      return state;
  }
};

export default appReportFilterFieldsReducer;
